import { render, staticRenderFns } from "./SafetyTopic.vue?vue&type=template&id=4ceb86d8&scoped=true&"
import script from "./SafetyTopic.vue?vue&type=script&lang=js&"
export * from "./SafetyTopic.vue?vue&type=script&lang=js&"
import style0 from "./SafetyTopic.vue?vue&type=style&index=0&id=4ceb86d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceb86d8",
  null
  
)

export default component.exports